import axios from "axios";
import React, { useState,  } from "react";
import { useParams } from "react-router-dom";

// const axios = require('axios');
const SettleExpenseModal = ({ isOpen, setModal, onClose, expenseData }) => {
  const [expenseName, setExpenseName] = useState("Settle");
  const [amount, setAmount] = useState(0);
  const user = JSON.parse(localStorage.getItem("user"));
  const { id } = useParams();
  const handleSaveExpense = async () => {
    const payload = {
      TotalAmount: parseFloat(amount),
      PaidBy: user.email,
      GroupId: id,
      Participants: [{UserId: expenseData.receiverId, Share: parseFloat(amount)}],
      Description: expenseName,
      IsSettle: true,
    };
    try {
      const res = await axios.post(
        "https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/expenses/create",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.idToken}`,
          },
        }
      );
      alert("Expense added successfully");
    } catch (error) {
      alert(error);
    }
    onClose();
  };

  

  return (
    <>
      {isOpen && (
        <div className="fixed w-full h-full top-0 left-0 z-10  inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 transition-opacity"
              aria-hidden="true"
            >
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>

            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>

            <div className="w-full inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full h-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                    <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
                      Add Expense
                    </h3>

                    <div className="mb-4">
                      <label
                        htmlFor="expenseName"
                        className="block overflow-hidden rounded-md border border-gray-200 px-3 py-2 shadow-sm focus-within:border-blue-600 focus-within:ring-1 focus-within:ring-blue-600"
                      >
                        <span className="text-xs font-medium text-gray-700">
                          {" "}
                          Expense Name{" "}
                        </span>

                        <input
                          type="text"
                          id="expenseName"
                          placeholder="Travel"
                          className="mt-1 w-full border-none p-0 focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                          required
                          value={expenseName || "Settle"}
                          onChange={(e) => setExpenseName(e.target.value)}
                        />
                      </label>
                    </div>

                    <div className="mb-4">
                      <label
                        htmlFor="amount"
                        className="block overflow-hidden rounded-md border border-gray-200 px-3 py-2 shadow-sm focus-within:border-blue-600 focus-within:ring-1 focus-within:ring-blue-600"
                      >
                        <span className="text-xs font-medium text-gray-700">
                          {" "}
                          Amount{" "}
                        </span>

                        <input
                          type="number"
                          id="amount"
                          className="mt-1 w-full border-none p-0 focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                          required
                          placeholder="0.00"
                          value={amount}
                          onChange={(e) =>
                            setAmount(parseFloat(e.target.value))
                          }
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 m-5 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() =>{ isNaN(amount)? alert("Please enter valid amount") : handleSaveExpense()}
                  }
                >
                  Save
                </button>
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => {
                    setModal(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SettleExpenseModal;
